import React from 'react';
import { NumericFormat } from 'react-number-format';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import {
  useStyles,
  AmountSubtitleTypography,
} from './toggleIconWithInputStyle';

const ToggleIcon = ({ isChecked }) => {
  const classes = useStyles();
  return (
    <span className={`${classes.icon} ${!isChecked && 'checked'}`}>
      {isChecked ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
    </span>
  );
};

export default function ToggleIconWithInput({
  amount,
  handleBlur,
  isChecked = false,
  disabled = false,
  centered = false,
  showRadioButton = true,
}) {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="nowrap"
      justifyContent={centered ? 'center' : 'flex-start'}
    >
      { showRadioButton && <ToggleIcon isChecked={isChecked} />}
      <Box className={classes.inputContainer}>
        <NumericFormat
          className={classes.input}
          value={amount}
          prefix="$"
          type="text"
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          placeholder="$0"
          maxLength={50}
          decimalScale={0}
          {...(!disabled && { onBlur: handleBlur })}
          allowNegative={false}
          disabled={disabled}
        />
      </Box>
      {disabled ? (
        <AmountSubtitleTypography>Confirm Your Amount</AmountSubtitleTypography>
      ) : (
        <AmountSubtitleTypography style={{ color: '#7b5599' }}>Enter Allocation Amount</AmountSubtitleTypography>
      )}
    </Box>
  );
}

ToggleIconWithInput.propTypes = {
  amount: PropTypes.number.isRequired,
  handleBlur: PropTypes.func,
  isChecked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  centered: PropTypes.bool,
  showRadioButton: PropTypes.bool,
};

ToggleIcon.propTypes = {
  isChecked: PropTypes.bool.isRequired,
};
